import { Component, OnInit } from '@angular/core';
import { AccountDeliveryAddress, AccountDeliveryAddressPronto } from '../../../../models/account-delivery-address';
import { CheckOutService } from '../../../../services/checkout.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CheckoutStatusModel } from '../../../../models/check-out.model';

@Component({
    selector: 'app-select-location',
    templateUrl: './select-location.component.html',
    styleUrls: ['./select-location.component.css']
})
export class SelectLocationComponent implements OnInit {

    setFullWindow: false;
    deliveryAddressList: AccountDeliveryAddress[];
    deliveryAddressListFilter: AccountDeliveryAddress[];
    deliveryAddress: AccountDeliveryAddress;
    cartId: string;
    cartName: string;
    title: string = "Select Location";
    displayedColumns: string[] = ['companyName', 'button'];
    searchLocation: string;
    checkoutStatus: CheckoutStatusModel;
    loadContent: boolean = false;  

    constructor(
        private checkOutService: CheckOutService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
    ) { }

    ngOnInit() {

        this.loadContent = false;

        this.activatedRoute.parent.parent.url.subscribe(value => {
            this.cartId = value.length > 1 ? value[1].path : '';
            this.cartName = value.length > 1 ? value[2].path : '';
        },
            (error: any) => {
                console.error(error);
                this.loadContent = true;
            });

        this.checkOutService.saveAddressWatch.subscribe(res => {
            this.checkOutService.getDeliveryAddressBook().subscribe((res: AccountDeliveryAddressPronto[]) => {
                this.deliveryAddressList = [];
                this.loadContent = true;
                this.deliveryAddressListFilter = [];
                res.map((value, key) => {
                    this.deliveryAddress = {
                        companyName: value.deliveryAddressLine1,
                        attnOrRef: value.deliveryAddressLine7,
                        addressLine1: value.deliveryAddressLine2,
                        addressLine2: value.deliveryAddressLine3,
                        addressLine3: value.deliveryAddressLine4,
                        suburb: value.deliveryAddressLine5,
                        state: value.deliveryAddressLine6,
                        postcode: value.postcode,
                        phone: value.phone,
                        naType: value.naType,
                        action: 'U',
                      combinedAddress: ""
                    }
                    this.deliveryAddressList.push(this.deliveryAddress);
                    this.deliveryAddressListFilter.push(this.deliveryAddress);
                });
            },
                (error: any) => {
                    console.info(error);
                    this.loadContent = true;
                });
        },
            (error: any) => {
                console.info(error);
                this.loadContent = true;
            });

        $('.page-contents').animate({
            scrollLeft: ($('#levelOne').outerWidth() + $('#cart-summary').outerWidth())
        }, 400);
    }

    onLoading(currentLoadingStatus: boolean) {
        this.loadContent = !currentLoadingStatus;
    }

    optionSelected(item: AccountDeliveryAddress): void {
        this.checkOutService.monitorSelectLocation(item);
        this.close();
    }

    filterLocation(): void {
        // this.deliveryAddressListFilter = this.deliveryAddressList.filter(address => address.companyName.toLowerCase().includes(this.searchLocation.toLowerCase()));
       this.deliveryAddressListFilter = this.deliveryAddressList.filter((address) => {
         const array: string[] = [];
         array.push(address.companyName, address.attnOrRef, address.addressLine1 + ' ' + address.addressLine2 + ' ' + address.addressLine3, address.suburb + ' ' + address.state + ' ' + address.postcode, address.phone);
         return array.some(line => line.toLocaleLowerCase().includes(this.searchLocation.toLowerCase()));
       });
    }

    close() {
        this.loadContent = true;
        this.router.navigate(['.'], { relativeTo: this.activatedRoute.parent });
        //this.router.navigateByUrl(`/myCarts/cart/${this.cartId}/${this.cartName}/ship-address`);
    }

}
